import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  header: {
    background: "#E8E8E8",
    display: "flex",
    alignItems: "center",
    height: "49px",
    padding: "0px 0px 0 15px",
    "& h1": {
      padding: "0px 15px",
      fontSize: "22px",
      fontWeight: 600,
      lineHeight: "28.8px",
      color: "#2D4D95",
    },
  },
  gridHeader: {
    padding: "6px 15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .HeaderDialog": {
      display: "flex",
      alignItems: "center",
      justifyContent: "right",
    },
  },
  gridActions: {
    textAlign: "right",
  },
  tabcontainer: {
    background: 'white',
    margin: '10px',
    padding: '10px 13px',
    borderRadius: '15px',
    "& .MuiTabs-flexContainer": {
      borderBottom: '1px solid #e1e1e1',
    },
    "& .MuiButtonBase-root": {
      color: '#424242',
      textTransform: 'capitalize',
      fontWeight: 600,
    },
    "& .MuiBox-root": {
      padding: '20px 5px'
    }
  },
  
}));